import Session, {
  LOCAL_STORAGE_SESSION_KEY,
  LOCAL_STORAGE_SESSION_MARKETPLACE_KEY,
} from 'utils/Session';
import axios from 'axios';

const addOptions = (options) => {
  const sessionKey = options?.marketplace
    ? LOCAL_STORAGE_SESSION_MARKETPLACE_KEY
    : LOCAL_STORAGE_SESSION_KEY;
  let token;
  if (options.accessToken) {
    token = options.accessToken;
  } else {
    const session = Session.get(null, sessionKey);
    token = session?.accessToken;
  }

  if (!token) {
    return options;
  }

  return {
    responseType: 'json',
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    },
  };
};

const client = axios.create();
const apiService = {};

apiService.request = (options) => {
  const updatedOptions = addOptions(options);
  return client.request(updatedOptions);
};

apiService.get = (url, options = {}) => {
  return apiService.request({
    url,
    method: 'get',
    ...options,
  });
};

apiService.post = (url, data, options = {}) => {
  return apiService.request({
    url,
    method: 'post',
    data,
    ...options,
  });
};

apiService.put = (url, data, options = {}) => {
  return apiService.request({
    url,
    method: 'put',
    data,
    ...options,
  });
};

apiService.patch = (url, data, options = {}) => {
  return apiService.request({
    url,
    method: 'patch',
    data,
    ...options,
  });
};

apiService.delete = (url, options = {}) => {
  return apiService.request({
    url,
    method: 'delete',
    ...options,
  });
};

apiService.client = client;

export default apiService;
